module.exports = __webpack_public_path__ + "PTMETTAservice-7.0566bf5c.png";